export const RESET_ALL_STATES = 'RESET_ALL_STATES';

export function resetAllStates(){
    return{
        type: RESET_ALL_STATES,
        mainState: {
        }
    }
}